<template>
    <ThePage>
        <template v-slot:goback>
            <router-link :to="{ name: 'vm', params: $route.params }"><i class="tlm-icon-chevron-left small mr-2" />Вернуться к автомату</router-link>
        </template>

        <template v-slot:title>Продукция автомата «{{ vm.name }}»</template>

        <!-- Мобила -->
        <div class="d-flex flex-row d-block d-xl-none mb-4">
            <button type="button" class="btn btn-lg btn-outline-primary flex-fill mr-1" style="line-height: 1; padding: 0" @click="showFormLayoutAdd = true">Добавить позицию</button>
            <button type="button" class="btn btn-lg btn-outline-primary flex-fill ml-1" style="line-height: 1; padding: 0" @click="showModalPlanogram">Заполнить из шаблона</button>
        </div>

        <!-- Мобила + Моник -->
        <ValidationObserver ref="obs" v-slot="{ invalid }" tag="form" class="form-thin" @submit.prevent="productAdd">
            <div class="d-none d-xl-flex flex-row mb-5">
                <div class="card flex-fill">
                    <div class="card-body card-body-search">
                        <form-layout-add ref="formLayoutAdd" :has-loading="hasLoading" @add="productAdd" />
                    </div>
                </div>

                <div class="flex-grow-1 right-column ml-3">
                    <button type="button" class="btn btn-lg btn-outline-primary h-100" @click="showModalPlanogram">Заполнить из шаблона</button>
                </div>
            </div>

            <!-- Мобила -->
            <div class="d-block d-sm-none font-weight-bold my-3">Продукция в автомате</div>

            <!-- Моник -->
            <div class="d-none d-xl-flex flex-row mb-3">
                <div class="font-weight-bold flex-fill">Продукты и рецепты</div>
                <div v-feature="'loading'" class="font-weight-bold right-column ml-3">Ингредиенты</div>
            </div>

            <!-- Мобила + Моник -->
            <div class="d-flex flex-column flex-xl-row">
                <form-layout-products :products="products" :has-loading="hasLoading" class="flex-fill mb-3 mb-xl-0" @update="updateProduct" @remove="remove" />
                <form-layout-components v-feature="'loading'" :components="components" class="right-column ml-xl-3" @update="updateRecipeComponent" />
            </div>
        </ValidationObserver>

        <TheModal v-if="showFormLayoutAdd" class="sm" @close="showFormLayoutAdd = false">
            <template v-slot:head>Добавить продукцию</template>
            <form-layout-add ref="formLayoutAdd" :has-loading="hasLoading" @add="productAdd" />
        </TheModal>

        <TheModal v-if="planogram.show" class="sm" @close="closeModalPlanogram">
            <template v-slot:head>Применить планограмму</template>

            <ValidationObserver ref="planogram" v-slot="{ invalid }" tag="form" class="form-thin" @submit.prevent="applyPlanogram">
                <ValidationProvider v-errors.api tag="div" class="form-group" vid="planogram_id" rules="required">
                    <select-planogram v-model="planogram.id" class="form-control" />
                </ValidationProvider>

                <button type="submit" :disabled="invalid" class="btn btn-lg-192 btn-primary">Применить</button>
            </ValidationObserver>
        </TheModal>
    </ThePage>
</template>

<script>
import ThePage from '@/components/ThePage'
import TheModal from '@/components/TheModal'

import FormLayoutAdd from '@/components/FormLayoutAdd'
import FormLayoutComponents from '@/components/FormLayoutComponents'
import FormLayoutProducts from '@/components/FormLayoutProducts'

import SelectPlanogram from '@/components/SelectPlanogram'

import store from '@/store'
import layout from '@/store/modules/layout'

import { toastSuccess, toastError } from '@/dialogs'
import axios from 'axios'

import { ValidationObserver, ValidationProvider } from 'vee-validate'

import { fetchOptions as fetchProducts } from '@/components/SelectProduct'

if (!store.state['vm-layout']) {
    store.registerModule('vm-layout', layout)
}

export default {
    components: {
        ThePage,
        TheModal,

        FormLayoutAdd,
        FormLayoutComponents,
        FormLayoutProducts,

        SelectPlanogram,

        ValidationObserver,
        ValidationProvider
    },

    data() {
        return {
            pending: false,

            planogram: {
                show: false,
                id: null
            },

            showFormLayoutAdd: false
        }
    },

    computed: {
        id() {
            return this.vm.id
        },

        vm() {
            return this.$store.state.vm.data
        },

        components() {
            return store.getters['vm-layout/components']
        },

        products() {
            return store.getters['vm-layout/products']
        },

        attributes() {
            return store.getters['vm-layout/normalized']
        },

        hasLoading() {
            return store.getters['company/hasLoading']
        }
    },

    destroyed() {
        store.commit('vm-layout/flush')
    },

    methods: {
        async productAdd({ product, product_number, max }) {
            try {
                await axios.post(`api/vms/${this.id}/layout`, { id: product.id, product_number, max })
                store.commit('vm-layout/add', { product, product_number, max })

                this.$refs.formLayoutAdd.reset()
                this.showFormLayoutAdd = false
            } catch (error) {
                this.$refs.formLayoutAdd.mixinApiErrors(error.response.data || null)
            }
        },

        async updateRecipeComponent({ id, max }) {
            try {
                const component = this.components.find(component => component.id === id)

                if (!component) {
                    return
                }

                await axios.put(`api/vms/${this.id}/layout-capacity`, [
                    { ...component, max }
                ])

                store.commit('vm-layout/updateRecipeComponent', { id, max })
            } catch (error) {
                console.log(error)
            }
        },

        async updateProduct({ index, product_number, max }) {
            try {
                const cpn = encodeURIComponent(this.products[index].product_number)
                await axios.put(`api/vms/${this.id}/layout/${cpn}`, { product_number, max })

                store.commit('vm-layout/updateProduct', { index, product_number, max })
            } catch (error) {
                console.log(error)
            }
        },

        async remove(index) {
            try {
                const product_number = encodeURIComponent(this.products[index].product_number)
                await axios.delete(`api/vms/${this.id}/layout/${product_number}`)

                store.dispatch('vm-layout/remove', index)
            } catch (error) {
                console.log(error)
            }
        },

        async applyPlanogram() {
            const isValid = this.$refs.planogram.validate()

            if (!isValid) {
                return
            }

            const done = await store.dispatch('vm/applyPlanogram', {
                vm_id: this.id,
                planogram_id: this.planogram.id
            })

            if (done) {
                const response = await axios.get(`api/vms/${this.id}/layout`)
                store.commit('vm-layout/init', response.data)

                this.closeModalPlanogram()

                toastSuccess('Планограмма применена')
            } else {
                toastError('Ошибка')
            }
        },

        showModalPlanogram() {
            this.planogram.show = true
        },

        closeModalPlanogram() {
            this.planogram.id = null
            this.planogram.show = false
        }
    },

    async beforeRouteEnter(to, from, next) {
        const promiseList = [
            fetchProducts(),
            axios.get(`api/vms/${to.params.id}/layout`)
        ]

        if (!store.state.vm.data.id) {
            promiseList.push(
                store.dispatch('vm/fetch', to.params.id)
            )
        }

        const done = await Promise.all(promiseList)

        if (done[1]) {
            store.commit('vm-layout/init', done[1].data)

            return next()
        }

        return next({ name: 'vms' })
    }
}
</script>
